import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { GENERAL_SETTINGS_LINK, MAGENTO_SETUP_LINK } from '../../../../../shared/navigation/constants';

@Component({
  selector: 'yi-magento2-enable-yotpo-module',
  template: require('./magento2_enable_yotpo_module.component.html'),
  styles: [require('./magento2_enable_yotpo_module.component.scss')]

})

export class Magento2EnableYotpoModuleComponent extends AccordionContentComponent {

  private composerLink = MAGENTO_SETUP_LINK;

  private generalSettingsLink = GENERAL_SETTINGS_LINK;

  openMagentoSetupLink() {
    this.redirectService.redirectTo(this.composerLink, true);
  }

  linkToCreds() {
    this.redirectService.redirectTo(this.generalSettingsLink, true);
  }
}
